import { CaptchaGuard } from './captcha.guard';
export const CAPTCHA_GUARDS = [CaptchaGuard];
export { CaptchaGuard };



// WEBPACK FOOTER //
// ./src/app/captcha/guards/index.ts